<template>
  <div class="container-fluid col-lg-10 offset-lg-1">
    <Wall :poster="poster" v-for="(poster) in posters" v-if="!isMobile()"/>
    <WallMobile :poster="poster" v-for="(poster) in posters" v-if="isMobile()"/>
  </div>
</template>

<script>
    const VueScrollTo = require('vue-scrollto');
    import {mapState} from 'vuex'
    import Wall from "../items/Wall";
    import WallMobile from "../items/WallMobile";

    export default {
        components: {Wall, WallMobile},
        data() {
            return {}
        },
        props: ['posters'],
        name: "listWall",
        methods: {
            scrollTo: function () {
                let scrollspeed = 500;
                if(this.$browserDetect.meta.name === 'Chrome') {
                    scrollspeed = 1500;
                }
                VueScrollTo.scrollTo('#poster' + this.$route.params.poster, scrollspeed, {easing: 'ease-in'});
            },
            getCollapseID(id) {
                while (id.includes(' ')) {
                    id = id.replace(' ', '');
                }
                while (id.includes(':')) {
                    id = id.replace(':', '');
                }
                return id;
            },
        },
        created() {
            if (!this.$store.state.ratings.length) {
                this.$store.dispatch('GET_ALL_RATINGS');
            }
        },
        mounted() {
            if (this.$route.params.poster > 0) {
                this.scrollTo();
            }
            this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'view/' + this.$store.state.mode.displayType, 'grouped:' + this.$store.state.mode.grouped.status);
        }
    }
</script>

<style scoped>
  .poster {
    /*border-bottom: solid 2px #7e7e7e;*/
  }

  .poster-text {
  }

  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }
</style>
